var mp = mp || {};

// Add Report Row
//-----------------------------------------------------------------
mp.addReportRow = function() {

    var $element = $('.js_addReportRow');
    if (!$element.length) {
        return;
    }

    var $rowIndex = $element.data('index');

    $(document).on('click','.js_addReportRow', function(e){
        e.preventDefault();

        $('.reportRows .rowIndex_0').clone().appendTo('.reportRows');

        var $lastRow = $('.reportRows .rowIndex_0').last();
        $lastRow.removeClass('rowIndex_0').addClass('rowIndex_'+$rowIndex);
        
        $lastRow.find('input').each(function(){
            $(this).attr("name", $(this).attr("name").replace(/\d+/, $rowIndex));
        });

        $lastRow.find('.time.start').val('08:00');
        $lastRow.find('.time.end').val('08:15');
        $lastRow.find('[name^="lokacija"]').val('');
        $lastRow.find('[name^="podijeljenih_simica"]').val('0');

        var $removeBtn = "<div class='col-md-2'><div class='form-group'><label>&nbsp;</label><div class='form-inline'><button data-row='"+$rowIndex+"' type='button' class='btn btn-danger js_removeReportRow'><i class='fa fa-times'></i></button></div></div></div>";
        $lastRow.append($removeBtn);

        $rowIndex++;
        mp.timePicker();
    });
};


// Remove Report Row
//-----------------------------------------------------------------
mp.removeReportRow = function() {

    var $element = $('.js_addReportRow');
    if (!$element.length) {
        return;
    }

    $(document).on('click','.js_removeReportRow', function(e){
        e.preventDefault();

        var $rowIndex = $(this).data('row');
        $('.reportRows .rowIndex_'+$rowIndex).remove();
    });
};



// Form validation 
//----------------------------------------------------------
mp.formValidationReports = function() {
    var $element = $('#ValidateForm__Reports');

    if (!$element.length) {
        return;
    }

    $element.validate({
        errorPlacement: function(error, element) {},
        ignore: [],
        rules: {
            "date": {
                required: true,
            },
            "timeStart[]": {
                required: true,
                minlength: 5
            },
            "timeEnd[]": {
                required: true,
                minlength: 5
            },
            "lokacija[]": {
                required: true,
                minlength: 2
            },
            "podijeljenih_simica[]": {
                required: true,
                min: 0
            },
        }
    });
};


$(document).ready(function (){
    mp.addReportRow();
    mp.removeReportRow();
    mp.formValidationReports();
});